import { faTimes } from "@jewlr/pro-regular-svg-icons/faTimes"
import { cva } from "class-variance-authority"
import PropTypes from "prop-types"
import { forwardRef, useState } from "react"

import { cn } from "styles/utils"

import Button from "./button"
import FontAwesomeIcon from "./font-awesome-icon"

const flashbarVariants = cva(
  "rounded-xs flex items-start border border-solid p-10",
  {
    defaultVariants: {
      type: "default",
    },
    variants: {
      type: {
        default: "border-grey-65 bg-grey-10 text-text",
        error: "border-[#f5c6cb] bg-[#f8d7da] text-[#721c24]",
        success: "border-[#c3e6cb] bg-[#d4edda] text-[#155724]",
      },
    },
  }
)

const Flashbar = forwardRef(
  ({ children, className, message, type, ...props }, ref) => {
    const [show, setShow] = useState(true)

    if (!show) return null

    return (
      <div
        className={cn(flashbarVariants({ className, type }))}
        ref={ref}
        {...props}
      >
        <div className="mr-4 flex-1">
          {children ? children : <p>{message}</p>}
        </div>
        <Button
          aria-label="Close message"
          onClick={() => setShow(false)}
          variant="text"
        >
          <FontAwesomeIcon className="text-black" icon={faTimes} />
        </Button>
      </div>
    )
  }
)

Flashbar.displayName = "Flashbar"

Flashbar.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  message: PropTypes.string,
  type: PropTypes.oneOf(["success", "error"]),
}

export default Flashbar
